import { render, staticRenderFns } from "./ManageRewards.vue?vue&type=template&id=4eec1cf4&scoped=true&"
import script from "./ManageRewards.vue?vue&type=script&lang=ts&"
export * from "./ManageRewards.vue?vue&type=script&lang=ts&"
import style0 from "./ManageRewards.vue?vue&type=style&index=0&id=4eec1cf4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec1cf4",
  null
  
)

export default component.exports